
import createChainedFunction from './utils/createChainedFunction'
import KeyCode from './utils/keyCode'
import {addEventListener, addFocusListener, stopKeyEventBubbles} from './eventListener'
import cssAnimation from './cssAnimation'
import toArray from './utils/toArray'

import * as Warning from './warning'
import WebUI, {prefix, getClsPrefix} from './config/updatePrefix'
import cssUtil, {parents, parent, parentsUntil} from './cssUtil'
import formatUtils from './formatUtils'
import {timezoneAdaptor} from './moment'
import getNid from './getNid'
import delayEvent from './delayPropEventUtil'
import fillSpace from './fillSpace'

import {myBrowser, measureScrollbar, debounce, detectZoom} from './browserUtils'
import isPlainObject from './utils/isPlainObject'
import {getChildrenText} from './ReactUtils'
import {matchAll, supportLookbehind} from './polyfill'
import {setComponentClass, setComponentSize} from './componentStyle';

import reactCompat from './reactCompat'
// import {tinperGetBoundingClientRect} from './getBoundingClientRect';

const {createRoot, startTransition, flushSync} = reactCompat

export {
    createChainedFunction,
    KeyCode,
    addEventListener,
    addFocusListener,

    cssAnimation,
    toArray,

    Warning,
    getNid,
    delayEvent,
    fillSpace,


    myBrowser,
    measureScrollbar,
    debounce,
    detectZoom,
    WebUI,
    prefix,
    cssUtil,
    formatUtils,
    timezoneAdaptor,
    parents,
    parent,
    parentsUntil,
    isPlainObject,
    getChildrenText,
    getClsPrefix,
    setComponentClass,
    setComponentSize,
    matchAll,
    supportLookbehind,
    stopKeyEventBubbles,
    createRoot,
    startTransition,
    flushSync
}
